<template>
  <div class="pre-visit-container">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template slot="basicInfo">
        <avue-form
          ref="form"
          v-model="addFormInfo"
          :option="addFormConfig"
          @submit="submitForm"
        >
          <template slot="files">
            <ImageUpload
              @showFileName="showFileName"
              fileMenuName="课程封面附件"
              :plain="true"
              :id="virtualId"
              ref="wordUpload"
              @getimages="getImages"
              :imageUrl="imagsrcTop"
            />
          </template>
          <template slot="videos">
            <div>
              <avue-crud :option="uploadConfig" :data="addFormInfo.videos">
                <template slot="seq" slot-scope="{ row }">
                  <el-input-number
                    v-model="row.seq"
                    :controls="false"
                  ></el-input-number>
                </template>
                <template slot="name" slot-scope="{ row }">
                  <el-input v-model="row.name"></el-input>
                </template>
                <template slot="intro" slot-scope="{ row }">
                  <el-input v-model="row.intro"></el-input>
                </template>

                <template slot="videoFiles" slot-scope="{ row }">
                  <div>
                   
                    <WordUploadVideo
                      :ossData="ossData"
                      fileMenuUrlName="课程附件"
                      v-if="row.videoFiles.length==0"
                      :tableIndex="row.$index"
                      @showFileName="showFileNameVideo"
                    />
                    <template v-for="(item, index_) in row.videoFiles" v-else >
                         <div class="file_wrapper" :key="index_">
                             {{ getFileName(item.name)}}
                             <i
                              @click="delFile(row.$index,index_)"
                              class="el-icon-circle-close del_icon" 
                              ></i>
                         </div>

                    </template>  
                  </div>
                </template>

                <template slot="action" slot-scope="{ row }">
                  <el-button
                    type="text"
                    @click="del(row.$index)"
                    plain
                    size="small"
                    icon="el-icon-delete-solid"
                    >删除
                  </el-button>
                </template>
              </avue-crud>
              <div class="action_add_wrapper" @click="add(-1)">
                <i class="el-icon-plus"></i> 新增
              </div>
            </div>
          </template>
        </avue-form>

        <div class="button-container">
          <el-button type="primary" @click="handleSubmit" style="width: 300px"
            >保存</el-button
          >
        </div>
      </template>
    </InfoContainer>
    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="false"
      @setDepartment="setDepartment"
    />
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/infoContainer";
import { addConfig, uploadConfig } from "./config";
import { queryInventedId } from "@/api/zg/zg";
import WordUpload from "@/components/wordUpload/wordUpload";
import { downLoadTemplate } from "@/router/downLoadTem";
import * as dictionaries from "@/api/zd/dictionaries";
import { mapGetters } from "vuex";
import { getUserDept } from "@/api/system/dept";
import ImageUpload from "@/components/wordUpload/wordUpload_imag";
import WordUploadVideo from "@/components/wordUpload/wordUpload_video";
import moment from "moment";
import SelectDepartment from "@/components/SelectDepartment/department";
import { validatenull } from "@/util/validate";
import { submitCourse, getDetailCourse } from "@/api/hr/cloudTraining";
import {
  generatePostPolicyVideo,
  generatePresignedUrl
} from "@/api/zd/dictionaries";

export default {
  name: "addAttendanceEvent",
  data() {
    var validateCurd = (rule, value, callback)=>{
      let nullList= value.filter(item=>{
        
        return validatenull(item.seq)||validatenull(item.name)||validatenull(item.intro)
      })
      let nullFileList= value.filter(item=>{
        return item.videoFiles.length==0
      })

      if (nullList.length > 0) {
        callback(new Error('请将表格填写完整'));
      }else if (nullFileList.length > 0) {
        callback(new Error('请上传视频附件'));
      }else {
        callback();
      }
    };
    

    return {
      id: "",
      virtualId: "",
      checkUserList: [],
      deptInfo: {},
      files: [],
      visitTime: "",
      addFormInfo: {
        videos: [],
      },
      addFormConfig: addConfig(this.selectDeptClick,validateCurd),
      InfoContainerConfig: {
        infoTitle: "新增云培训",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      baFileMenuId: "",
      imagsrcTop: "",
      checkdepartment: [],
      uploadConfig: uploadConfig(),
      ossData:{}
    };
  },
  components: {
    InfoContainer,
    WordUpload,
    ImageUpload,
    SelectDepartment,
    WordUploadVideo,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    getFileName(){
      return function(name){
        
        let fileSub = (name+'').substring((name+'').lastIndexOf('_')+1)
        let fileName=fileSub.length>12?fileSub.substr(0,8):fileSub
        let ext = fileSub.length>12?fileSub.substring(fileSub.lastIndexOf('.')):''
        return  `${fileName}${ext ? `${ext}` : ''}`
      }
    },
  },
  mounted() {
    if (this.$route.params.id == -1) {
      this.buildId();
      this.getDept(this.userInfo.user_id,this.userInfo.user_name);

    } else {
      this.virtualId = this.$route.params.id;
      this.InfoContainerConfig.infoTitle = "编辑云培训";
      // 编辑页，查询详情数据
      this.queryDetail();
    }
    this.configData()
    
  },

  methods: {
    configData() {
      let that = this;
      generatePostPolicyVideo({ dir: "" }).then((result) => {
       
        this.ossData = {
          policy: result.data.data.policy,
          OSSAccessKeyId: result.data.data.accessid,
          signature: result.data.data.signature,
          host: result.data.data.host,
          success_action_status: 200,
        };
        if (that && !that.timeStatus) {
              that.timer = window.setTimeout(() => {
                that.configData();
              }, 10*1000*60);//token过期时间10分钟
       }
      });
    },
    // 获取部门
    async getDept(userId,userName) {
      getUserDept({ userId: userId }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data.map((item) => {
            return {
              label: item.deptName,
              value: item.id,
            };
          });
          if (data.length > 0) {
            this.addFormInfo.createDept = data[0].value;
            this.addFormInfo.createDeptName = data[0].label;
            this.addFormInfo.createUser = userId;
            this.addFormInfo.createUserName = userName;
          }
        }
      });
    },

    // 查询详情
    queryDetail() {
      let self = this;
      getDetailCourse({ id: this.$route.params.id })
        .then((res) => {
          if (res.data.code == 200) {
            let dataInfo=res.data.data
            dataInfo.virtualId=dataInfo.id
            dataInfo.videos=dataInfo.videos.map(item=>{
              return {
                ...item,
                videoFiles:[{
                  url:item.url,
                  name:item.path
                }]
              }
            })
            self.addFormInfo = dataInfo
            this.getDept(self.addFormInfo.createUser,self.addFormInfo.createUserName);
            this.getDeptList(self.addFormInfo.visibleDeptIds)
            // 查询附件
            // self.getFileMenuByName();
          }
        });
    },

    // getFileMenuByName() {
    //   dictionaries
    //     .getFileMenuByName({ fileMenuName: "课程封面附件" })
    //     .then((res) => {
    //       this.baFileMenuId = res.data.data.id;
    //       this.getFileName();
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },

    // getFileName() {
    //   let self = this;
    //   let params = {
    //     fileOtherId: this.$route.params.id,
    //     baFileMenuId: this.baFileMenuId,
    //   };
    //   dictionaries.findFileByOtherId(params).then((res) => {
    //     if (res["data"]["data"]["length"] > 0) {
    //       self.files = res.data.data;
    //     }
    //   });
    // },

    

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    

    //新增上传
    add() {
      this.addFormInfo.videos.push({
        courseId: undefined,
        name: undefined,
        path: undefined,
        intro: undefined,
        videoFiles:[],
        createTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
    },

    //删除上传
    del(index) {
      let that = this;

      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.addFormInfo.videos.splice(index, 1);
        
        
      });
    },
    handleSubmit() {
      let self = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            ...this.addFormInfo,
            id: this.virtualId,
            videos:this.addFormInfo.videos.map(item=>{
              return {
                ...item,
                path:item.videoFiles.map(el=>{
                  return  el.name
                }).join(",")
              }
            })
          };
          submitCourse(params).then((res) => {
            self.$message({
              type: "success",
              message: "保存成功!",
            });
            self.$router.push({
              path: `/cloudTraining/detail/${res.data.data}`
            })
            // self.$router.go(-1);
          });
        }else {
           this.$message.warning('请将表单内容补充完整')
        }
      });
    },
    
    buildId() {
      let self = this;
      queryInventedId().then((res) => {
        if (res["data"]["code"] == 200) {
          self.virtualId = res["data"]["data"];
          self.addFormInfo.virtualId = res["data"]["data"];
        }
      });
    },
    //部门选择插件打开
    selectDeptClick() {
      this.$refs.selectdepartment.showModel();
    },
    //部门 获取
    setDepartment(data = []) {
      if (!data || data.length == 0) {
        this.checkdepartment = [];
      } else {
        this.checkdepartment = data;
        let titleList = data.map((item) => {
          return item.title || item.fullName;
        });
        let ids = data.map((item) => {
          return item.key;
        });
        this.$nextTick(() => {
          this.addFormInfo.visibleDeptName = titleList.join(",");
          this.addFormInfo.visibleDeptIds = ids.join(",");
        });
      }
    },
    getDeptList(value = "",) {
      let ids = value ? value.split(",") : [];
      if (ids.length == 0) {
        return;
      }
      dictionaries
        .getDeptList({
          ids: ids,
        })
        .then((res) => {
          this.checkdepartment = res.data.data;
          let titleList = res.data.data.map((item) => {
            item.key = item.id;
            return item.title || item.fullName;
          });

          this.addFormInfo.visibleDeptName = titleList.join(",");
          this.addFormInfo.visibleDeptIds = ids.join(",");
        })
        .catch((res) => {
          
        });
    },
    //附件内容
    showFileName(data) {
      this.getImages(data);
    },
    getImages(data) {
     
      this.addFormInfo.files =
        data.length == 0 ? this.imagsrcTop : data[0].fileUrl;
      this.imagsrcTop = data.length == 0 ? this.imagsrcTop : data[0].fileUrl;
      
    },

    //获取附件
    showFileNameVideo(data, index) {
      
      this.addFormInfo.videos[index].videoFiles=data
      this.addFormInfo.videos[index].createTime=moment().format("YYYY-MM-DD HH:mm:ss")
      this.$refs.form.clearValidate();
      
    },
    //删除附件
    delFile(index, index_) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
           
        })
        .then(() => {
          this.addFormInfo.videos[index].videoFiles.splice(index_, 1);
          // this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    
  },
};
</script>
<style lang="scss" scoped>
.pre-visit-container {
  .button-container {
    text-align: center;
  }
}

/deep/.info-container-temp .box-card .detail-one {
  padding: 20px 0px !important;
}
.avue-crud__menu {
  display: none;
}
/deep/.avue-crud__pagination {
  display: none !important;
}
/deep/ .avue-crud {
  width: 100%;
}
.action_add_wrapper {
  width: 100%;
  border: 1px solid #ebeef5;
  border-top-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  color: #4b8cff;
  font-size: 13px;
  cursor: pointer;
  .el-icon {
    margin-right: 4px;
  }
}
/deep/.el-collapse {
        border: none !important;
      }
</style>